export var sortObjects = function (objects) {
    return objects.sort(function (a, b) { return a.name.localeCompare(b.name); });
};
